module.exports = {
    "zhcn": require("./zhcn.js"),
    "zhhk": require("./zhhk.js"),
    "zhtw": require("./zhtw.js"),
    "areg": require("./areg.js"),
    "jajp": require("./jajp.js"),
    "vivn": require("./vivn.js"),
    "enus": require("./enus.js"),
    "frfr": require("./frfr.js"),
    "ptpt": require("./ptpt.js"),
    "ruru": require("./ruru.js"),
    "kokr": require("./kokr.js"),
    "eses": require("./eses.js"),
    "trtr": require("./trtr.js"),
    "idid": require("./idid.js"),
    "msmy": require("./msmy.js"),
    "thth": require("./thth.js"),
    "itit": require("./itit.js"),
    "nlnl": require("./nlnl.js"),
};


// WEBPACK FOOTER //
// ./js/lang/pack.js